module.exports = __webpack_public_path__ + "static/media/gaming_mouse.5194ca50.png";